function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module engine/model/operation/rootattributeoperation
 */
import Operation from './operation';
import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
/**
 * Operation to change root element's attribute. Using this class you can add, remove or change value of the attribute.
 *
 * This operation is needed, because root elements can't be changed through
 * @link module:engine/model/operation/attributeoperation~AttributeOperation}.
 * It is because {@link module:engine/model/operation/attributeoperation~AttributeOperation}
 * requires a range to change and root element can't
 * be a part of range because every {@link module:engine/model/position~Position} has to be inside a root.
 * {@link module:engine/model/position~Position} can't be created before a root element.
 *
 * @extends module:engine/model/operation/operation~Operation
 */

var RootAttributeOperation =
/*#__PURE__*/
function (_Operation) {
  _inherits(RootAttributeOperation, _Operation);

  /**
   * Creates an operation that changes, removes or adds attributes on root element.
   *
   * @see module:engine/model/operation/attributeoperation~AttributeOperation
   * @param {module:engine/model/rootelement~RootElement} root Root element to change.
   * @param {String} key Key of an attribute to change or remove.
   * @param {*} oldValue Old value of the attribute with given key or `null` if adding a new attribute.
   * @param {*} newValue New value to set for the attribute. If `null`, then the operation just removes the attribute.
   * @param {Number|null} baseVersion Document {@link module:engine/model/document~Document#version} on which operation
   * can be applied or `null` if the operation operates on detached (non-document) tree.
   */
  function RootAttributeOperation(root, key, oldValue, newValue, baseVersion) {
    var _this;

    _classCallCheck(this, RootAttributeOperation);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RootAttributeOperation).call(this, baseVersion));
    /**
     * Root element to change.
     *
     * @readonly
     * @member {module:engine/model/rootelement~RootElement}
     */

    _this.root = root;
    /**
     * Key of an attribute to change or remove.
     *
     * @readonly
     * @member {String}
     */

    _this.key = key;
    /**
     * Old value of the attribute with given key or `null` if adding a new attribute.
     *
     * @readonly
     * @member {*}
     */

    _this.oldValue = oldValue;
    /**
     * New value to set for the attribute. If `null`, then the operation just removes the attribute.
     *
     * @readonly
     * @member {*}
     */

    _this.newValue = newValue;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(RootAttributeOperation, [{
    key: "clone",

    /**
     * Creates and returns an operation that has the same parameters as this operation.
     *
     * @returns {module:engine/model/operation/rootattributeoperation~RootAttributeOperation} Clone of this operation.
     */
    value: function clone() {
      return new RootAttributeOperation(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
    }
    /**
     * See {@link module:engine/model/operation/operation~Operation#getReversed `Operation#getReversed()`}.
     *
     * @returns {module:engine/model/operation/rootattributeoperation~RootAttributeOperation}
     */

  }, {
    key: "getReversed",
    value: function getReversed() {
      return new RootAttributeOperation(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_validate",
    value: function _validate() {
      if (this.root != this.root.root || this.root.is('documentFragment')) {
        /**
         * The element to change is not a root element.
         *
         * @error rootattribute-operation-not-a-root
         * @param {module:engine/model/rootelement~RootElement} root
         * @param {String} key
         * @param {*} value
         */
        throw new CKEditorError('rootattribute-operation-not-a-root', this, {
          root: this.root,
          key: this.key
        });
      }

      if (this.oldValue !== null && this.root.getAttribute(this.key) !== this.oldValue) {
        /**
         * The attribute which should be removed does not exists for the given node.
         *
         * @error rootattribute-operation-wrong-old-value
         * @param {module:engine/model/rootelement~RootElement} root
         * @param {String} key
         * @param {*} value
         */
        throw new CKEditorError('rootattribute-operation-wrong-old-value', this, {
          root: this.root,
          key: this.key
        });
      }

      if (this.oldValue === null && this.newValue !== null && this.root.hasAttribute(this.key)) {
        /**
         * The attribute with given key already exists for the given node.
         *
         * @error rootattribute-operation-attribute-exists
         * @param {module:engine/model/rootelement~RootElement} root
         * @param {String} key
         */
        throw new CKEditorError('rootattribute-operation-attribute-exists', this, {
          root: this.root,
          key: this.key
        });
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "_execute",
    value: function _execute() {
      if (this.newValue !== null) {
        this.root._setAttribute(this.key, this.newValue);
      } else {
        this.root._removeAttribute(this.key);
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = _get(_getPrototypeOf(RootAttributeOperation.prototype), "toJSON", this).call(this);

      json.root = this.root.toJSON();
      return json;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "type",
    get: function get() {
      if (this.oldValue === null) {
        return 'addRootAttribute';
      } else if (this.newValue === null) {
        return 'removeRootAttribute';
      } else {
        return 'changeRootAttribute';
      }
    }
  }], [{
    key: "fromJSON",

    /**
     * Creates RootAttributeOperation object from deserilized object, i.e. from parsed JSON string.
     *
     * @param {Object} json Deserialized JSON object.
     * @param {module:engine/model/document~Document} document Document on which this operation will be applied.
     * @returns {module:engine/model/operation/rootattributeoperation~RootAttributeOperation}
     */
    value: function fromJSON(json, document) {
      if (!document.getRoot(json.root)) {
        /**
         * Cannot create RootAttributeOperation for document. Root with specified name does not exist.
         *
         * @error rootattribute-operation-fromjson-no-root
         * @param {String} rootName
         */
        throw new CKEditorError('rootattribute-operation-fromjson-no-root', this, {
          rootName: json.root
        });
      }

      return new RootAttributeOperation(document.getRoot(json.root), json.key, json.oldValue, json.newValue, json.baseVersion);
    } // @if CK_DEBUG_ENGINE // toString() {
    // @if CK_DEBUG_ENGINE // 	return `RootAttributeOperation( ${ this.baseVersion } ): ` +
    // @if CK_DEBUG_ENGINE //		`"${ this.key }": ${ JSON.stringify( this.oldValue ) }` +
    // @if CK_DEBUG_ENGINE //		` -> ${ JSON.stringify( this.newValue ) }, ${ this.root.rootName }`;
    // @if CK_DEBUG_ENGINE // }

  }, {
    key: "className",
    get: function get() {
      return 'RootAttributeOperation';
    }
  }]);

  return RootAttributeOperation;
}(Operation);

export { RootAttributeOperation as default };